import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseApiTemplateService } from '../shared/base-api-template-service.model';
import { Core2Config } from '../shared/core2Config';
import { EInvoiceEmailOcrDocHdrContainerModel } from '../../../../../models/aggregates/e-invoice/bl_fi_einvoice_email_ocr_doc_hdr_container.model';
import { ApiVisa } from '../shared';
import { Observable } from 'rxjs';
import { EInvoiceEmailOcrReprocessDto } from '../../data-transfer-objects';
import { BasicApiResponseModel } from '../shared/api-response.model';
@Injectable({
  providedIn: 'root'
})
export class EInvoiceEmailOcrDocHdrService extends BaseApiTemplateService<EInvoiceEmailOcrDocHdrContainerModel> {

  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'e-invoice/email-ocr-docs/backoffice-ep';
  endpoint_path_without_ep: string;

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'e-invoice/email-ocr-docs/backoffice-ep'
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'e-invoice/email-ocr-docs/backoffice-ep'
    this.endpoint_path_without_ep = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'e-invoice/email-ocr-docs/';
    this.httpClient = http;
  }

  getFile(guid, visa: ApiVisa): Observable<Blob> {
    let url;
    if (this.endpoint_path && visa.api_domain_url) {
      url = visa.api_domain_url + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'e-invoice/email-ocr-docs/file/backoffice-ep/' + guid;
    }
    return this.httpClient.get<Blob>(url, this.getHttpHeaderBlob(visa));
  }

  public uploadImportFile(formData: FormData, visa: ApiVisa) {
    if (this.endpoint_path_without_ep && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path_without_ep;
    }
    const url = this.apiUrl + 'upload-file/' + Core2Config.BACKOFFICE_EP_SUFFIX;
    return this.httpClient.post(url, formData, this.getHttpHeader(visa));
  }

  public reprocess(processRequest: EInvoiceEmailOcrReprocessDto, visa: ApiVisa): Observable<any> {
    let url;
    if (this.endpoint_path_without_ep && visa.api_domain_url) {
      url = visa.api_domain_url + this.endpoint_path_without_ep + 'reprocess/' + Core2Config.BACKOFFICE_EP_SUFFIX;
    }
    return this.httpClient.post<any>(
      url,
      processRequest,
      this.getHttpHeader(visa)
    );
  }

  public getByGuidLoginConsolidatedArap(
    guid: string,
    visa: ApiVisa
  ): Observable<BasicApiResponseModel<EInvoiceEmailOcrDocHdrContainerModel>> {
    if (this.endpoint_path_without_ep && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path_without_ep + Core2Config.LOGIN_CONSOLIDATED_ARAP_EP_SUFFIX;
    }
    return this.httpClient.get<BasicApiResponseModel<EInvoiceEmailOcrDocHdrContainerModel>>(
      this.apiUrl + '/' + guid,
      this.getHttpHeader(visa)
    );
  }
}
